import { IOrderList } from 'core/model/interfaces/orders';
import { apiService } from 'core/services';
import type { IGetOrdersRequest } from 'core/services/orders/orders.dto';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../orders.constants';
import type { IOrdersState } from '../orders.type';

export const fetchOrderList = createAppAsyncThunk<IOrderList, void | { page?: number }>(
  `${SLICE_NAMESPACE}/fetchOrderList`,
  async (data, { getState }) => {
    try {
      const { page } = data || {};
      const { orders } = getState();
      const { orderListPagination, filters } = orders;
      const { currentPage, itemsPerPage } = orderListPagination;
      const { ByOrder, ByClient } = filters;

      const params: IGetOrdersRequest = {
        ...(ByOrder && { orderFilter: ByOrder }),
        ...(ByClient && { customerFilter: ByClient }),
        itemsPerPage,
        page: page ?? currentPage,
      };

      return await apiService.orders.getOrders(params);
    } catch (error) {
      notificationService.global.error(handleErrorMessage(error, 'Falló al obtener la lista de pedidos.'));

      throw error;
    }
  },
);

export const fetchOrderListReducer: TSliceExtraReducer<IOrdersState> = builder =>
  builder
    .addCase(fetchOrderList.pending, state => {
      state.orderList.isLoading = true;
    })
    .addCase(fetchOrderList.fulfilled, (state, action) => {
      state.orderList.data = action.payload.orders;
      state.orderListPagination.totalPages = action.payload.pagination.totalPages;
      state.orderListPagination.currentPage = action.payload.pagination.currentPage;
      state.orderListPagination.totalItems = action.payload.pagination.totalItems;
      state.orderList.isLoading = false;
      state.orderList.error = null;
    })
    .addCase(fetchOrderList.rejected, (state, action) => {
      state.orderList.isLoading = false;
      state.orderList.data = [];
      state.orderList.error = action.error.message ?? '';
    });
